{
  "schema_version": 1,
  "task_id": "L5-EXTERNAL-ACTION-SAFETY-HARNESS-001",
  "status": "safety-harness-ready",
  "generated_at": "2026-07-31T08:15:00+08:00",
  "source_templates": "config/l5-user-decision-task-spec-templates.json",
  "authority_boundary": {
    "observational_only": true,
    "local_check_only": true,
    "fail_closed": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "embeds_secret_values": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "external_message": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "controlled_action_count": 3,
    "can_execute_now_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "precondition_total": 24,
    "default_result": "blocked_until_all_preconditions_pass"
  },
  "harness_contract": {
    "templates_are_non_executable": true,
    "missing_precondition_blocks": true,
    "secret_value_blocks": true,
    "explicit_user_go_required": true,
    "independent_reviewer_required": true,
    "evidence_required": true,
    "rollback_required": true,
    "cost_boundary_required": true,
    "no_external_effects_during_check": true
  },
  "controlled_actions": [
    {
      "id": "real-cloud-sync",
      "decision_id": "L5-REAL-CLOUD-SYNC-USER-DECISION-001",
      "template_id": "TEMPLATE-REAL-CLOUD-SYNC",
      "template_path": "docs/specs/L5-REAL-CLOUD-SYNC-ACTIVATION-TASK-SPEC.template.md",
      "evidence_target": "artifacts/evidence/L5-REAL-CLOUD-SYNC-ACTIVATION-001",
      "can_execute_now": false,
      "blocked_until_all_preconditions_pass": true,
      "required_preconditions": [
        "user_choice_supplied_out_of_band",
        "all_user_fill_placeholders_resolved_without_secret_values",
        "secret_injection_path_confirmed_without_secret_value",
        "cost_budget_confirmed",
        "data_scope_and_no_clobber_policy_confirmed",
        "rollback_owner_confirmed",
        "independent_reviewer_pass",
        "explicit_user_go"
      ],
      "forbidden_without_user_go": [
        "cloud_read",
        "cloud_write",
        "external_write",
        "paid_action",
        "store_secret",
        "runtime_activation"
      ]
    },
    {
      "id": "ecosystem-publishing",
      "decision_id": "L5-ECOSYSTEM-PUBLISHING-ACTIVATION-USER-DECISION-001",
      "template_id": "TEMPLATE-ECOSYSTEM-PUBLISHING",
      "template_path": "docs/specs/L5-ECOSYSTEM-PUBLISHING-ACTIVATION-TASK-SPEC.template.md",
      "evidence_target": "artifacts/evidence/L5-ECOSYSTEM-PUBLISHING-ACTIVATION-001",
      "can_execute_now": false,
      "blocked_until_all_preconditions_pass": true,
      "required_preconditions": [
        "user_choice_supplied_out_of_band",
        "publication_target_confirmed",
        "license_and_attribution_review_pass",
        "publishing_account_boundary_confirmed",
        "cost_and_quota_policy_confirmed",
        "unpublish_path_confirmed",
        "independent_reviewer_pass",
        "explicit_user_go"
      ],
      "forbidden_without_user_go": [
        "publish_plugin",
        "publish_skill",
        "submit_marketplace",
        "external_distribution",
        "external_write",
        "external_message",
        "paid_action",
        "store_secret",
        "runtime_activation"
      ]
    },
    {
      "id": "production-external-distribution",
      "decision_id": "L5-EXTERNAL-DISTRIBUTION-USER-DECISION-001",
      "template_id": "TEMPLATE-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "template_path": "docs/specs/L5-PRODUCTION-EXTERNAL-DISTRIBUTION-TASK-SPEC.template.md",
      "evidence_target": "artifacts/evidence/L5-PRODUCTION-EXTERNAL-DISTRIBUTION-001",
      "can_execute_now": false,
      "blocked_until_all_preconditions_pass": true,
      "required_preconditions": [
        "user_choice_supplied_out_of_band",
        "legal_account_confirmed",
        "distribution_policy_confirmed",
        "cost_and_support_boundary_confirmed",
        "rollback_and_incident_plan_confirmed",
        "external_communication_boundary_confirmed",
        "independent_reviewer_pass",
        "explicit_user_go"
      ],
      "forbidden_without_user_go": [
        "production_distribution",
        "deployment",
        "external_write",
        "external_message",
        "paid_action",
        "store_secret",
        "runtime_activation"
      ]
    }
  ],
  "handoff_integration": {
    "project_status": "config/aios-project-status.json",
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "task_spec_templates": "config/l5-user-decision-task-spec-templates.json",
    "must_remain_fail_closed": true,
    "must_not_execute_external_actions": true,
    "must_not_store_user_choices": true,
    "must_not_collect_secrets": true
  }
}
